<!--
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
-->
<!-- IP-NOTICE: PROTECTED -->
<div [formGroup]="dataForm" class="aside-content aside-width-3">
  <div class="aside-header flex-layout-row flex-layout-align-space-between-center">
    <h3>{{ saveText }} Time Provider</h3>
    <div class='flex-layout-gap-10px'>
      <button mat-raised-button (click)="save()" color="primary">{{ saveText }}</button>
      <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
  </div>
  <div>
    <div>Current time is {{ currentDateTime() | date: 'dd-MMM-yyyy hh:mm' }}</div>
    <div>
      <mat-checkbox formControlName="realTime">Real Time</mat-checkbox>
    </div>
    <div *ngIf="showIncremental()">
      <mat-checkbox formControlName="incrementTime">Incremental Time</mat-checkbox>
    </div>

    <div *ngIf="showIncremental() && incrementTime.value">
      <input matInput formControlName="incrementDays" />
    </div>
    <div *ngIf="showFixed() && !incrementTime.value">
      <mat-checkbox formControlName="fixedTime">Fixed Time</mat-checkbox>
    </div>
    <div *ngIf="showFixed() && !incrementTime.value">
      <mat-form-field>
        <mat-label>Choose a Date</mat-label><input formControlName="baseDate" matInput [matDatepicker]="dpBaseDate" />
        <mat-datepicker-toggle matSuffix [for]="dpBaseDate"></mat-datepicker-toggle>
        <mat-datepicker #dpBaseDate></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
</div>
